import { render, staticRenderFns } from "./MarketHeader.vue?vue&type=template&id=7dd9f559&scoped=true&"
import script from "./MarketHeader.vue?vue&type=script&lang=js&"
export * from "./MarketHeader.vue?vue&type=script&lang=js&"
import style0 from "./MarketHeader.vue?vue&type=style&index=0&id=7dd9f559&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd9f559",
  null
  
)

export default component.exports